import ApplicationAdapter from "./application";

export default class LoadBalancerTargetAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    let listener = snapshot.belongsTo("listener");

    return `${this.apiBaseUri}/loadbalancer/addtarget?loadbalancerid=${listener.belongsTo("loadBalancer").id}&backendname=${listener.attr("backend")}`;
  }

  urlForDeleteRecord(_id, _, snapshot) {
    let listener = snapshot.belongsTo("listener");

    return `${this.apiBaseUri}/loadbalancer/removetarget?loadbalancerid=${listener.belongsTo("loadBalancer").id}&backendname=${listener.attr("backend")}&name=${snapshot.attr("name")}`;
  }

  urlForUpdateRecord(_id, _, snapshot) {
    let listener = snapshot.belongsTo("listener");

    return `${this.apiBaseUri}/loadbalancer/edittarget?loadbalancerid=${listener.belongsTo("loadBalancer").id}&backendname=${listener.attr("backend")}&targetname=${snapshot.attr("name")}`;
  }

  async createRecord(store, type, snapshot) {
    let payload = await super.createRecord(...arguments);
    let listener = snapshot.belongsTo("listener");
    let backendname = listener.attr("backend");
    let name = snapshot.attr("name");

    if (!snapshot.attr("active")) {
      payload = await this.ajax(
        `${this.apiBaseUri}/loadbalancer/disabletarget?loadbalancerid=${listener.belongsTo("loadBalancer").id}&backendname=${backendname}&targetname=${name}`,
        "POST",
      );
    }

    return this.targetFrom(payload, backendname, name);
  }

  async updateRecord(store, type, snapshot) {
    let payload = await super.updateRecord(...arguments);

    return this.targetFrom(payload, snapshot.belongsTo("listener").attr("backend"), snapshot.attr("name"));
  }

  enable(target) {
    return this.changeStatus(target, "enabletarget");
  }

  disable(target) {
    return this.changeStatus(target, "disabletarget");
  }

  async changeStatus(target, action) {
    let { listener } = target;
    let loadBalancerId = listener.loadBalancer.id;
    let backendname = listener.backend;

    let payload = await this.ajax(
      `${this.apiBaseUri}/loadbalancer/${action}?loadbalancerid=${loadBalancerId}&backendname=${backendname}&targetname=${target.name}`,
      "POST",
    );

    this.store.push(this.store.normalize("load-balancer-target", this.targetFrom(payload, backendname, target.name)));
  }

  targetFrom(payload, backendname, targetname) {
    let { loadbalancer } = payload.response;
    let backend = loadbalancer.backends.find((backend) => backend.name === backendname);
    let target = backend.targets.find((target) => target.name === targetname);

    return { ...target, id: `${loadbalancer.loadbalancerid}_${target.name}` };
  }
}
